import { PublicClientApplication } from '@azure/msal-browser';
import config from './config';

export const msalConfig = {
  auth: {
    clientId: config.microsoft.clientId,
    authority: `https://login.microsoftonline.com/${config.microsoft.tenantId}`,
    redirectUri: `${window.location.origin}/login`,
    postLogoutRedirectUri: '/',
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'User.Read', 'email'],
};

export const msalInstance = new PublicClientApplication(msalConfig);
